import { Component, OnInit } from '@angular/core';
import { PersonnelListTableConfig } from "./personnel-list.table-config";
import { BrokerAdminService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
@Component({
  selector: 'app-personnel-list',
  templateUrl: './personnel-list.component.html',
  styleUrls: ['./personnel-list.component.scss']
})
export class PersonnelListComponent implements OnInit {
  editPanel: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []

  constructor(
    private brokerAdminService: BrokerAdminService
  ) { }

  ngOnInit(): void {
    this.dataSource = new Array(30).fill({
      firstName: "test",
      email: "email",
      businessName: "bussiness"
    })
    this.config = PersonnelListTableConfig.configure();
    this.getList();
  }

  getList() {
    // this.brokerAdminService.list().subscribe({
    //   next: (res: any) => {
    //     this.dataSource = res.data
    //   }
    // })
  }

  action(e: any) {
    if(e.button.eventName == "edit") {
      this.editPanel = true;
    }
    if(e.button.eventName == "add") {
      this.editPanel = true;
    }
  }

}
